
<div class="ng-autocomplete body-b1 InputSearchDrop" [ngClass]="{ 'openDropdown':isFocused, 'searchIcon': searchIcon,'shipError':noShipFound,'isSearchVal':isserachText}">
    <ng-autocomplete #auto
        [data]="data"
        [placeholder] ="label"
        [searchKeyword]="keyword"
        (selected)='selectEvent($event)'
        (inputChanged)='onChangeSearch($event)'
        (inputCleared) = 'onClearSearch()'
        (inputFocused)='onFocused($event)'       
        [itemTemplate]="itemTemplate"
        [notFoundTemplate]="notFoundTemplate">
    </ng-autocomplete>
     <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>
    
  
    <ng-template #notFoundTemplate let-notFound>
      <div *ngIf="!addShipErrormsg">No items found</div>
      <div *ngIf="addShipErrormsg" class="addShipErrormsg body-b1">
        <figure class="errorImg">
          <img alt="add" src="/assets/img/errorIcon.svg">
        </figure>
        <span class="addShipErrormsgText">No ship name found</span>
      </div>
    </ng-template>
   
</div>
<span class="shipPlaceholder" [ngClass]="{'shipError':noShipFound}" *ngIf="isFocused || isserachText">Ship</span>
  